<!-- Este componente carga el layout de la ruta y aquí debe de estar toda la parte visual independiente de layout, pej un footer... -->
<template>
    <div id="root-component">
        <Component :is="$route.meta.layout || 'div'">
            <RouterView></RouterView>
        </Component>
    <footer>
        <!-- Este span hay que dejarlo en algún sitio donde no moleste. Sirve para mostrar en depuración el id del tab
        -->
        <span v-if="id" class="d-none">
            IdTab: {{ id }}
        </span>
    </footer>
    </div>
    
</template>

<script setup lang="ts">
    import { ref } from "vue";
    import {RouterView} from "vue-router";

    const id = ref<string | null>(null);

    if (import.meta.env.VITE_IS_DEBUG === "true") {
        id.value =  (window as any)["instance_id"] ;
    }
</script>